<script setup lang="ts">
import { initAccordions } from 'flowbite'
import { CtIcon } from '@camelot/components'

const props = defineProps<{
  index: number
  question: string
  answer: string
  total: number
}>()

onMounted(() => initAccordions())

const answersAsList = getListItems()

function getListItems(): string[] | undefined {
  return props.answer.trimStart().startsWith('1') ? props.answer.split('\n') : undefined
}
</script>

<template>
  <section>
    <div :id="`accordion-collapse-heading-${props.index}`" class="py-16 pl-0 hover:bg-cotton">
      <button
        type="button"
        class="flex items-center justify-between w-full"
        aria-expanded="false"
        :data-accordion-target="`#accordion-collapse-body-${props.index}`"
        :aria-controls="`accordion-collapse-body-${props.index}`"
      >
        <p class="font-bold text-left text-black-100">
          {{ props.question }}
        </p>
        <CtIcon data-accordion-icon name="chevron_down" color="--ct-color-black-100" class="w-6 h-6 shrink-0 chevron-color" />
      </button>
    </div>

    <div
      :id="`accordion-collapse-body-${props.index}`"
      class="hidden leading-relaxed pl-16 pb-16"
      :aria-labelledby="`accordion-collapse-heading-${props.index}`"
    >
      <p v-if="!answersAsList">
        {{ props.answer }}
      </p>
      <ol v-else-if="answersAsList.length > 0">
        <li v-for="(ul, i) in answersAsList" :key="i">
          {{ ul }}
        </li>
      </ol>
    </div>

    <hr v-if="total > props.index + 1" class="w-full border-b-2 border-black-20 rounded-md">
  </section>
</template>

<style scoped lang="scss">
.linter-error-when-no-style-section {
  color: inherit;
}
</style>
